import { apiCardEmSecondAuthFirst } from '@/api';
import main from '@/main';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBar from '../../components/appBar';
import Page from '../../components/page';
import { LoadingMask, showToast } from '../../utils/utils';

export default function CertifiedEquipmentPage() {
  const navigate = useNavigate();
  const [mobileMac, setmobileMac] = useState<string>();
  const [emMac, setemMac] = useState<string>();

  async function handCardEmSecondAuthFirst() {
    let msg = '';
    if (!emMac) {
      msg = '请输入设备MAC地址';
    } else if (!mobileMac) {
      msg = '请输入连接设备MAC地址';
    }
    if (!!msg) {
      showToast(msg);
      return;
    }
    LoadingMask.show('加载中...');
    try {
      let res = await apiCardEmSecondAuthFirst({ emNumber: main.currentEm?.emNumber!, emMac, mobileMac });
      let data = res.data;
      if (data.code === 200) {
        if (data?.data.includes('http')) {
          window.location.href = data?.data;
        }
      } else {
        showToast(data.msg ?? '认证失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '认证失败');
    } finally {
      LoadingMask.hide();
    }
  }

  return (
    <Page
      className="d-flex-c bg-gray"
      contentClassName="flex-1 d-flex-c h-1 overflow-y"
      appBar={
        <AppBar
          title="认证新设备"
          onBack={() => {
            navigate(-1);
          }}
        />
      }
    >
      <div className="certified-equipment m-10">
        <input
          className="input-block bw-100 bg-white p-15 border-radius-20 pl-20 border mb-15 mt-20"
          type="text"
          placeholder="请输入设备MAC地址"
          value={emMac}
          onChange={(v) => setemMac(v.target.value)}
        />
        <input
          className="input-block bw-100 bg-white p-15 border-radius-20 pl-20 border mb-20"
          type="text"
          placeholder="请输入连接设备MAC地址"
          value={mobileMac}
          onChange={(v) => setmobileMac(v.target.value)}
        />
        <div
          className="bg-blue-color-t8 border-radius-30 pt-15 pb-15 text-color-white text-center font-size-16"
          onClick={handCardEmSecondAuthFirst}
        >
          开始认证
        </div>
        <img className="mt-40 bw-100" src="/pic/certified_bg.png" alt="" />
      </div>
    </Page>
  );
}
